module.exports = __webpack_public_path__ + "img/star.34ebebbf.svg";